import React from 'react';

const Blog: React.FC = () => {
  return (
    <div className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Blog</h1>
          <p className="text-xl text-gray-600">
            Latest insights, tips, and updates from the AICaFriend team.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Blog;